// extracted by mini-css-extract-plugin
var _1 = "copy__rr_YN";
var _2 = "header__Q8ffo";
var _3 = "info__GS5Tq";
var _4 = "info--error__I4VNO";
var _5 = "info--warning__KFveR";
export { _1 as "copy", _2 as "header", _3 as "info", _4 as "info--error", _5 as "info--warning" }
